import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';

const FieldDefinitionHK = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: false,
    validate: [max.lengthPostCode(16)],
  },
  companyName,
  nameNumber,
  streetName,
  {
    ...addressLine2,
    maxLength: 35,
    validate: [max.lengthAddress(35)],
  },
  {
    ...townCity,
    maxLength: 20,
    validate: [required.townCity, max.lengthAddress(20)],
  },
  {
    ...county,
    maxLength: 20,
    validate: [max.lengthAddress(20)],
  },
];

export default FieldDefinitionHK;
